const params = new URLSearchParams(window.location.search);
// This list should be kept up-to-date with relevant exposed view filters.
const exposedParams = ['page', 'news_type'];

const setViewsScrollingPosition = () => {
  const scrollAnchor = document.querySelector('.container--qs-scroll-anchor');
  const shouldScroll = exposedParams.some((parameter) => params.has(parameter));
  if (scrollAnchor && shouldScroll) {
    window.scrollTo({
      top: scrollAnchor.offsetTop,
      behavior: 'smooth',
    });
  }
};

document.addEventListener('DOMContentLoaded', () =>
  setViewsScrollingPosition(),
);
